import { useMutationEndpoint, UseMutationOptionsFromProvider } from '../../core'
import { postAuthManagementMfaSelfDisable } from '../endpoints'

type MutationParams = Parameters<typeof postAuthManagementMfaSelfDisable>[0]

export const useAuthManagementMfaSelfDisablePostMutation = (
  options?: UseMutationOptionsFromProvider<
    typeof postAuthManagementMfaSelfDisable,
    MutationParams
  >,
) => useMutationEndpoint(postAuthManagementMfaSelfDisable, options)
